import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const faqs = [
  {
    question: "What industries does Zola support?",
    answer:
      "Zola is built to support a wide range of service-based industries, including real estate, home maintenance and repair, hospitality, restaurants, and other customer-facing businesses. If your business depends on customer satisfaction and team performance, Zola is for you.",
  },
  {
    question: "How does Zola track employee performance?",
    answer:
      "Zola tracks employee performance using a combination of customer feedback, internal review data, and platform interactions. Managers can view individual and team performance dashboards, identify trends, and even tie customer reviews directly to specific employees.",
  },
  {
    question: "Can Zola pull reviews from different platforms?",
    answer:
      "Yes! Zola aggregates reviews from major platforms like Google, Yelp, and TripAdvisor, giving you a unified view of your brand reputation in one dashboard. No more switching between tabs or missing critical feedback.",
  },
  {
    question: "What types of surveys can Zola send?",
    answer:
      "Zola uses AI-powered, dynamic surveys that adapt to your customer interactions. You can send NPS (Net Promoter Score), CSAT (Customer Satisfaction), and custom surveys to gather detailed insights and improve your services in real-time.",
  },
  {
    question: "Does Zola support referral or coupon campaigns?",
    answer:
      "Yes! Zola includes built-in tools for launching customer referral programs, digital coupon campaigns, and loyalty incentives. It’s an easy way to turn happy customers into repeat business and word-of-mouth growth.",
  },
  {
    question: "Can I respond to reviews directly through Zola?",
    answer:
      "Absolutely. Zola not only aggregates reviews but also allows you to respond directly to reviews from Google, Yelp, and other platforms—helping you manage your reputation quickly and professionally.",
  },
];

const FAQSection = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.25,
  });

  return (
    <section className="w-full bg-white py-20" ref={ref}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Heading */}
        <motion.div
          initial={{ y: -30, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <p className="text-xs text-[#7f56d9] font-medium uppercase tracking-widest mb-4">
            Support
          </p>
          <h2 className="text-3xl md:text-5xl font-semibold text-gray-900">
            FAQs
          </h2>
        </motion.div>

        {/* FAQ Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-left">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ y: 40, opacity: 0 }}
              animate={inView ? { y: 0, opacity: 1 } : {}}
              transition={{
                duration: 0.6,
                delay: 0.2 + index * 0.1,
                ease: "easeOut",
              }}
            >
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h4>
              <p className="text-gray-600 text-base">{faq.answer}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
